export enum DropdownOption {
    All = '*',
    None = '',
}

export const PERMISSIONS = [
    {
        label: 'Users',
        key: 'custom:UserEditRole',
    },
    {
        label: 'Prices',
        key: 'custom:PriceEditRole',
    },
    {
        label: 'Stores',
        key: 'custom:StoreEditRole',
    },
    {
        label: 'Products',
        key: 'custom:ProductEditRole',
    },
    {
        label: 'Designs',
        key: 'custom:UploaderRole',
    },
] as const;
